module.exports = __webpack_public_path__ + "static/media/ne.345dc2db.svg";